export const createCanvas = (width: number, height: number) => {
    if (typeof OffscreenCanvas !== 'undefined') {
        return new OffscreenCanvas(width, height);
    }
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
};

export const canvasToBlob = (canvas: OffscreenCanvas | HTMLCanvasElement, mimeType = 'image/png'): Promise<Blob> => {
    if (typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas && 'convertToBlob' in canvas) {
        const offscreenCanvas = canvas as OffscreenCanvas;
        return offscreenCanvas.convertToBlob({
            type: mimeType
        });
    }

    // Regular HTMLCanvasElement
    const htmlCanvas = canvas as HTMLCanvasElement;
    return new Promise<Blob>((resolve, reject) => {
        htmlCanvas.toBlob((blob: Blob | null) => {
            if (blob) {
                resolve(blob);
            } else {
                reject(new Error('Failed to convert canvas to blob'));
            }
        }, mimeType);
    });
};

export const blobToBase64 = async (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();

        fileReader.onload = () => {
            if (typeof fileReader.result === 'string') {
                resolve(fileReader.result);
            } else {
                reject(new Error('Failed to read Blob: No result'));
            }
        };

        fileReader.onerror = () => {
            reject(new Error(`Failed to read Blob: ${fileReader.error?.message || 'Unknown error'}`));
        };

        fileReader.readAsDataURL(blob);
    });
};
